import { getTaskStatus, pollAndWaitTask } from "../api";
import { 
    UsersResponse, 
    MenuItem, 
    AddUserResponse, 
    AddUserFormData, 
    ModifyUserResponse, 
    ModifyUserFormData, 
    APIResult, 
    APIError, 
    GroupsResponse, 
    AddGroupResponse, 
    AddGroupFormData, 
    ModifyGroupResponse, 
    ModifyGroupFormData, 
    LogmonResponse, 
    CreateContainerFormData, 
    RenameContainerFormData, 
    UploadFileFormData, 
    FileInfo,
    ListFilesResponse,
    ListFilesSort,
    ModifySystemPromptData,
    UpdateSystemPromptFormData, 
    UpdateGroupData, 
    UpdateGroupFormData, 
    UserPromptExampleData,
    UpdateUserPromptExampleFormData,
    UpdateContainerTagsFormData,
    UpdateFileTagsFormData,
    CostsResponse, 
    OutputCSVAllResponse, 
    OutputCSVAllFormData, 
    NGWordsResponse, 
    AddNGWordResponse, 
    ModifyNGWordResponse, 
    AddNGWordFormData, 
    ModifyNGWordFormData, 
    FunctionsResponse, 
    ModifyFunctionResponse, 
    ModifyFunctionFormData, 
    PromptTemplatesResponse, 
    CreatePromptCategoryFormData, 
    UpdatePromptCategoryFormData, 
    DeletePromptCategoryFormData, 
    SwapPromptCategoryOrderFormData, 
    SwapPromptTemplateOrderFormData, 
    DeletePromptTemplateFormData, 
    ResetPasswordResponse, 
    ResetPasswordFormData, 
    ImportUsersCheckResponse, 
    ImportUsersCheckFormData, 
    ImportUsersSubmitFormData, 
    UploadFileResultData,
    StartPreprocessFormData,
    TaskStartResult,
    ContainerInfo,
    ContainerListData,
    RunIndexerResult
} from "./models_admin";

export const getErrorMes = async (res: Response) => {
    try {
        const jsoned = await res.json()
        if ("error" in jsoned) {
            return String(jsoned.error)
        }
        else if ("message" in jsoned) {
            return String(jsoned.message)
        }
    } catch(e) {
        
    }
    if(res.status == 403) {
        return "権限がありません"
    }
    else if (res.status == 401) {
        return 'ログインが必要です。アクセスするにはログインしてください。'
    }
    return "予期しないエラーが発生しました"
}

export const getMenuList = async (): Promise<MenuItem[] | APIError> => {
    const response = await fetch(`/api/menu`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const getUsers = async (): Promise<UsersResponse | APIError> => {
    const response = await fetch(`/api/users`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const deleteUser = async (userid: string): Promise<APIResult> => {
    const formData = new FormData();
    formData.append('userid', userid);
    
    const response = await fetch(`/api/delete_user`, {
        method: "POST",
        body: formData
    })
    
    return await response.json()
}

export const getAddUserData = async (): Promise<AddUserResponse | APIError> => {
    const response = await fetch(`/api/add_user`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const addUser = async (formData: AddUserFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('userid', formData.userid);
    form.append('username', formData.username);
    form.append('username_alphabet', formData.username_alphabet);
    form.append('password', formData.password);
    form.append('authority_level', formData.authority_level);
    
    formData.groups.forEach((groupCd: string, index: number) => {
        form.append(`group_cd${index + 1}`, groupCd);
    });
    
    const response = await fetch(`/api/add_user`, {
        method: "POST",
        body: form
    })
    
    return await response.json()
}

export const getModifyUserData = async (userid: string): Promise<ModifyUserResponse | APIError> => {
    const response = await fetch(`/api/modify_user?user_id=${userid}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const modifyUser = async (formData: ModifyUserFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('userid', formData.userid);
    form.append('username', formData.username);
    form.append('username_alphabet', formData.username_alphabet);
    form.append('authority_level', formData.authority_level);
    
    formData.groups.forEach((groupCd: string, index: number) => {
        form.append(`group_cd${index + 1}`, groupCd);
    });
    
    const response = await fetch(`/api/modify_user`, {
        method: "POST",
        body: form
    })

    return await response.json()
}

export const getGroups = async (): Promise<GroupsResponse | APIError> => {
    const response = await fetch(`/api/groups`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const deleteGroup = async (groupCd: string): Promise<APIResult> => {
    const formData = new FormData();
    formData.append('group_cd', groupCd);
    
    const response = await fetch(`/api/delete_group`, {
        method: "POST",
        body: formData
    })
    
    return await response.json()
}

export const getAddGroupData = async (): Promise<AddGroupResponse | APIError> => {
    const response = await fetch(`/api/add_group`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const addGroup = async (formData: AddGroupFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('group_cd', formData.group_cd);
    form.append('group_name', formData.group_name);
    form.append('select_model', formData.select_model);
    
    if (formData.check_setting_rag_flag) {
        form.append('check_setting_rag_flag', '1');
    }
    
    const response = await fetch(`/api/add_group`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const getModifyGroupData = async (groupCd: string): Promise<ModifyGroupResponse | APIError> => {
    const response = await fetch(`/api/modify_group?group_cd=${groupCd}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const modifyGroup = async (formData: ModifyGroupFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('group_cd', formData.group_cd);
    form.append('new_group_name', formData.group_name);
    form.append('select_model', formData.select_model);
    
    if (formData.check_setting_rag_flag) {
        form.append('check_setting_rag_flag', '1');
    }
    
    const response = await fetch(`/api/modify_group`, {
        method: "POST",
        body: form
    })

    return await response.json()
}

export const getLogmon = async (startdate?: string, enddate?: string): Promise<LogmonResponse | APIError> => {
    const params = new URLSearchParams();
    if (startdate) params.append('startdate', startdate);
    if (enddate) params.append('enddate', enddate);
    
    const response = await fetch(`/api/logmon?${params.toString()}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const extractFilename = (contentDisposition: string, defaultName: string) => {
    let filename = defaultName;
    if (contentDisposition) {
        const match = contentDisposition.match(/filename\*?=(?:UTF-8''|"?)([^";]+)"?/i);
        if (match) {
            filename = decodeURIComponent(match[1]);
        }
    }
    return filename
}

export const downloadBlob = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    return;
}

export const getLogmonCsv = async (startdate?: string, enddate?: string): Promise<null | APIError> => {
    const params = new URLSearchParams();
    if (startdate) params.append('startdate', startdate);
    if (enddate) params.append('enddate', enddate);
    
    const response = await fetch(`/api/logmon/csv?${params.toString()}`, {
        method: "GET",
    })
    if (response.ok) {
        const blob = await response.blob();
        const disposition = response.headers.get('Content-Disposition');
        const filename = disposition ? extractFilename(disposition, 'login_monitoring.csv') : 'login_monitoring.csv'
        downloadBlob(blob, filename)
        return null;
    }
    return {error: await getErrorMes(response)}
}

export const getContainerList = async (): Promise<ContainerListData | APIError> => {
    const response = await fetch(`/api/containers/list`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const getContainer = async (container_seq: number): Promise<ContainerInfo | APIError> => {
    const response = await fetch(`/api/containers/${container_seq}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const createContainer = async (formData: CreateContainerFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('container_name', formData.container_name);
    
    const response = await fetch(`/api/make_container`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const renameContainer = async (formData: RenameContainerFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('container_seq', formData.container_seq.toString());
    form.append('new_container_name', formData.new_container_name);
    
    const response = await fetch(`/api/rename_container`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const deleteContainer = async (containerSeq: number): Promise<APIResult> => {
    const form = new FormData();
    form.append('container_seq', containerSeq.toString());
    
    const response = await fetch(`/api/delete_container`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const uploadFile = async (formData: UploadFileFormData): Promise<UploadFileResultData> => {
    const form = new FormData();
    form.append('container_seq', formData.container_seq.toString());
    form.append('file', formData.file);
    
    const response = await fetch(`/api/upload_file`, {
        method: "POST",
        body: form
    })
    const json = await response.json()
    return json
}

export const documentPreprocess = async (formData: StartPreprocessFormData): Promise<boolean> => {
    const form = new FormData();
    form.append('filename', formData.filename);
    form.append('container_seq', formData.container_seq.toString());
    form.append('preprocess', formData.preprocess);
    form.append('args', JSON.stringify(formData.args))
    
    const response = await fetch(`/api/start_preprocess`, {
        method: "POST",
        body: form
    })

    const startResult: TaskStartResult = await response.json()
    if (startResult.error !== undefined) {
        return false
    }
    const pollResult = await pollAndWaitTask(startResult.task_id, formData.onProgress)
    if (pollResult === undefined) {
        return false
    }

    return pollResult.status === "completed"
}

export const getAdminTaskStatus = getTaskStatus

export const getPreprocessDocumentsDownloadURL = (container_seq: number, filename: string) => {
    return `/api/download/preprocess/${container_seq}?filename=${filename}`
}

export const runIndexer = async (formData: {container_seq: number}): Promise<RunIndexerResult> => {
    const form = new FormData();
    form.append('container_seq', formData.container_seq.toString());

    const response = await fetch(`/api/run_indexer`, {
        method: "POST",
        body: form
    })

    // 412は文書検索が未設定のカテゴリ。索引自体が無いので反映するものが無く、エラーではない
    if (response.status === 412) {
        return {
            success: true,
            notConfigured: true,
            message: "このカテゴリは文書検索設定がされていないため、検索への反映は不要です"
        }
    }

    const result: APIResult = await response.json();
    return {
        ...result,
        // サーバが文言を返さなかった場合の既定。呼び出し側ではそのまま表示すればよい
        message: result.message ?? (result.success
            ? "検索への反映を開始しました。完了には時間がかかることがあります。"
            : "検索への反映に失敗しました。時間をおいて再度実行してください。")
    }
}

export const swapContainerOrderUp = async (containerSeq: number): Promise<APIResult> => {
    const form = new FormData();
    form.append('container_seq', containerSeq.toString());
    
    const response = await fetch(`/api/swap_container_order_up`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const swapContainerOrderDown = async (containerSeq: number): Promise<APIResult> => {
    const form = new FormData();
    form.append('container_seq', containerSeq.toString());
    
    const response = await fetch(`/api/swap_container_order_down`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const makeAiSearch = async (containerSeq: number): Promise<APIResult> => {
    const form = new FormData();
    form.append('container_seq', containerSeq.toString());
    
    const response = await fetch(`/api/make_aisearch`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const deleteAiSearch = async (containerSeq: number): Promise<APIResult> => {
    const form = new FormData();
    form.append('container_seq', containerSeq.toString());
    
    const response = await fetch(`/api/delete_aisearch`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

// ファイル一覧のlimit/offset/ソート指定をクエリ文字列に変換する
const buildListFilesQuery = (limit: number, offset: number, sort?: ListFilesSort): string => {
    const params = new URLSearchParams({
        limit: limit.toString(),
        offset: offset.toString(),
    });
    if (sort) {
        params.set('sort', sort.key);
        params.set('order', sort.descending ? 'desc' : 'asc');
    }
    return params.toString();
}

export const getListFiles = async (containerSeq: number, limit: number, offset: number, sort?: ListFilesSort): Promise<ListFilesResponse | APIError> => {
    const url = `/api/list_files/${containerSeq}?${buildListFilesQuery(limit, offset, sort)}`;
    const response = await fetch(url, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const getListFilesAllPages = async (
    containerSeq: number,
    onProgress?: (loaded: number, total: number) => void
): Promise<ListFilesResponse | APIError> => {
    const pageSize = 500;
    const files: FileInfo[] = [];
    let total = 0;

    while (true) {
        const page = await getListFiles(containerSeq, pageSize, files.length);
        if ("error" in page) {
            return page;
        }
        total = page.total;
        files.push(...page.files);
        onProgress?.(files.length, total);
        // 満たないページが返ったら終端。offsetは必ずpageSize進むのでループは有限
        if (page.files.length < pageSize || files.length >= total) {
            break;
        }
    }
    return { files, total };
}

export const deleteFile = async (fileSeq: number, containerSeq: number): Promise<APIResult> => {
    const form = new FormData();
    form.append('seq', fileSeq.toString());
    form.append('container_seq', containerSeq.toString());
    
    const response = await fetch(`/api/delete_file`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const getModifySystemPromptData = async (seq: string): Promise<ModifySystemPromptData | APIError> => {
    const response = await fetch(`/api/update_system_prompt/${seq}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const updateSystemPrompt = async (formData: UpdateSystemPromptFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('category', formData.category);
    form.append('new_prompt', formData.new_prompt);
    
    const response = await fetch(`/api/update_system_prompt`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const getUpdateGroupData = async (seq: string): Promise<UpdateGroupData | APIError> => {
    const response = await fetch(`/api/update_group/${seq}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const updateGroup = async (formData: UpdateGroupFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('category', formData.category);
    formData.groupCodes.forEach((code, index) => {
        if (code) {
            form.append(`group_cd${index + 1}`, code);
        }
    });
    
    const response = await fetch(`/api/update_group`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const getUserPromptExampleData = async (seq: string): Promise<UserPromptExampleData | APIError> => {
    const response = await fetch(`/api/user_prompt_example/${seq}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const updateUserPromptExample = async (formData: UpdateUserPromptExampleFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('category', formData.category);
    Object.entries(formData.prompts).forEach(([key, value]) => {
        form.append(`new_prompt${key}`, value);
    });
    
    const response = await fetch(`/api/update_user_prompt_example`, {
        method: "POST",
        body: form
    })
    return await response.json()
}

export const updateContainerTags = async (formData: UpdateContainerTagsFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('tags', JSON.stringify(formData.tags));

    const response = await fetch(`/api/tags/container/${formData.seq}`, {
        method: "PUT",
        body: form
    })
    return await response.json()
}

export const updateFileTags = async (formData: UpdateFileTagsFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('tag_keys', JSON.stringify(formData.tagKeys));

    const response = await fetch(`/api/tags/container/${formData.cntSeq}/file/${formData.filSeq}`, {
        method: "PUT",
        body: form
    })
    return await response.json()
}

export const getCosts = async (year?: number, month?: number): Promise<CostsResponse | APIError> => {
    let url = '/api/costs';
    if (year !== undefined && month !== undefined) {
        url += `?year=${year}&month=${month}`;
    }
    
    const response = await fetch(url, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const getOutputCSVAllData = async (): Promise<OutputCSVAllResponse | APIError> => {
    const response = await fetch(`/api/outputcsvall`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const downloadOutputCSVAll = async (formData: OutputCSVAllFormData): Promise<Blob | APIError> => {
    const form = new FormData();
    
    if (formData.startdate) {
        form.append('startdate', formData.startdate);
    }
    if (formData.enddate) {
        form.append('enddate', formData.enddate);
    }
    
    formData.userids.forEach(userid => {
        form.append('userid', userid);
    });
    
    formData.group_cds.forEach(groupCd => {
        form.append('group_cd', groupCd);
    });
    
    const response = await fetch(`/api/outputcsvall`, {
        method: "POST",
        body: form
    })
    
    if (response.ok) {
        return await response.blob();
    }
    return {error: await getErrorMes(response)};
}


export const getNGWords = async (): Promise<NGWordsResponse | APIError> => {
    const response = await fetch(`/api/ngwordslist`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const deleteNGWord = async (seq: number): Promise<APIResult> => {
    const formData = new FormData();
    formData.append('seq', seq.toString());
    
    const response = await fetch(`/api/delete_ngword`, {
        method: "POST",
        body: formData
    })
    
    return await response.json()
}

export const getAddNGWordData = async (): Promise<AddNGWordResponse | APIError> => {
    const response = await fetch(`/api/add_ngword`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const addNGWord = async (formData: AddNGWordFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('ng_word', formData.ng_word);
    form.append('ng_level', formData.ng_level);
    form.append('group_cd', formData.group_cd);
    
    const response = await fetch(`/api/add_ngword`, {
        method: "POST",
        body: form
    })
    
    return await response.json()
}

export const getModifyNGWordData = async (seq: string): Promise<ModifyNGWordResponse | APIError> => {
    const response = await fetch(`/api/modify_ngword?seq=${seq}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const modifyNGWord = async (formData: ModifyNGWordFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('seq', formData.seq);
    form.append('ng_level', formData.ng_level);
    form.append('group_cd', formData.group_cd);
    
    const response = await fetch(`/api/modify_ngword`, {
        method: "POST",
        body: form
    })

    return await response.json()
}

export const getFunctions = async (): Promise<FunctionsResponse | APIError> => {
    const response = await fetch(`/api/functions`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const getModifyFunctionData = async (functionId: string): Promise<ModifyFunctionResponse | APIError> => {
    const response = await fetch(`/api/modify_function?function_id=${functionId}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const modifyFunction = async (formData: ModifyFunctionFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('function_id', formData.function_id);
    form.append('function_name', formData.function_name);
    form.append('route_name', formData.route_name);
    form.append('need_authority_level', formData.need_authority_level);
    
    const response = await fetch(`/api/modify_function`, {
        method: "POST",
        body: form
    })

    return await response.json()
}

// Prompt Template関連
export const getPromptTemplates = async (): Promise<PromptTemplatesResponse | APIError> => {
    const response = await fetch(`/api/prompt_templates_list`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const createPromptCategory = async (formData: CreatePromptCategoryFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('mode', 'create');
    form.append('name', formData.name);
    
    const response = await fetch(`/api/prompt_template_categories`, {
        method: "POST",
        body: form
    })
    
    if (response.ok) {
        return { success: true }
    }
    
    const result = await response.json()
    return {
        success: false,
        message: result.message || result.error || "カテゴリの作成に失敗しました"
    }
}

export const updatePromptCategory = async (formData: UpdatePromptCategoryFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('mode', 'patch');
    form.append('category_id', formData.category_id.toString());
    form.append('name', formData.name);
    
    const response = await fetch(`/api/prompt_template_categories`, {
        method: "POST",
        body: form
    })
    
    if (response.ok) {
        return { success: true }
    }
    
    const result = await response.json()
    return {
        success: false,
        message: result.message || result.error || "カテゴリの更新に失敗しました"
    }
}

export const deletePromptCategory = async (formData: DeletePromptCategoryFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('mode', 'delete');
    form.append('category_id', formData.category_id.toString());
    
    const response = await fetch(`/api/prompt_template_categories`, {
        method: "POST",
        body: form
    })
    
    if (response.ok) {
        return { success: true }
    }
    
    const result = await response.json()
    return {
        success: false,
        message: result.message || result.error || "カテゴリの削除に失敗しました"
    }
}

export const swapPromptCategoryOrder = async (formData: SwapPromptCategoryOrderFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('mode', formData.mode);
    form.append('id', formData.id.toString());
    
    const response = await fetch(`/api/prompt_template_categories`, {
        method: "POST",
        body: form
    })
    
    if (response.ok) {
        return { success: true }
    }
    
    const result = await response.json()
    return {
        success: false,
        message: result.message || result.error || "並び順の変更に失敗しました"
    }
}

export const swapPromptTemplateOrder = async (formData: SwapPromptTemplateOrderFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('mode', formData.mode);
    form.append('id', formData.id.toString());
    
    const response = await fetch(`/api/prompt_templates`, {
        method: "POST",
        body: form
    })
    
    if (response.ok) {
        return { success: true }
    }
    
    const result = await response.json()
    return {
        success: false,
        message: result.message || result.error || "並び順の変更に失敗しました"
    }
}

export const deletePromptTemplate = async (formData: DeletePromptTemplateFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('mode', 'delete');
    form.append('template_id', formData.template_id.toString());
    
    const response = await fetch(`/api/prompt_templates`, {
        method: "POST",
        body: form
    })
    
    if (response.ok) {
        return { success: true }
    }
    
    const result = await response.json()
    return {
        success: false,
        message: result.message || result.error || "テンプレートの削除に失敗しました"
    }
}

// Reset Password関連
export const getResetPasswordData = async (userid: string): Promise<ResetPasswordResponse | APIError> => {
    const response = await fetch(`/api/reset_password?user_id=${userid}`, {
        method: "GET",
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const resetPassword = async (formData: ResetPasswordFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('userid', formData.userid);
    form.append('password', formData.password);
    
    const response = await fetch(`/api/reset_password`, {
        method: "POST",
        body: form
    })

    if (response.ok) {
        return { success: true }
    }
    
    const result = await response.json()
    return {
        success: false,
        message: result.message || "パスワードの変更に失敗しました"
    }
}

// Import Users関連
export const checkImportUsers = async (formData: ImportUsersCheckFormData): Promise<ImportUsersCheckResponse | APIError> => {
    const form = new FormData();
    form.append('user_import_file', formData.file);
    form.append('state', 'check');
    
    const response = await fetch(`/api/import_users`, {
        method: "POST",
        body: form
    })
    if (response.ok) {
        return await response.json()
    }
    return {error: await getErrorMes(response)}
}

export const submitImportUsers = async (formData: ImportUsersSubmitFormData): Promise<APIResult> => {
    const form = new FormData();
    form.append('jsoned_csv_info', formData.jsoned_csv_info);
    form.append('state', 'submit');
    
    const response = await fetch(`/api/import_users`, {
        method: "POST",
        body: form
    })

    return await response.json()
}
